/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ArticleType {
  Court = "Court",
  Long = "Long",
}

export enum CreatedSiteStatus {
  Creating = "Creating",
  Done = "Done",
  Error = "Error",
}

export enum CustomerSortField {
  createdAt = "createdAt",
  hidden = "hidden",
  name = "name",
  site = "site",
}

export enum CustomerStatus {
  Converti = "Converti",
  Prospect = "Prospect",
}

export enum CustomerTaskStatus {
  Done = "Done",
  InProgress = "InProgress",
  Todo = "Todo",
}

export enum FindBySource {
  Autre = "Autre",
  Google = "Google",
  PagesJaunes = "PagesJaunes",
}

export enum MailDirection {
  Incoming = "Incoming",
  Outgoing = "Outgoing",
}

export enum ProspectionType {
  Email = "Email",
  Phone = "Phone",
  Sms = "Sms",
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum UserRole {
  Admin = "Admin",
  Client = "Client",
  Employee = "Employee",
}

export interface ArticlesFiltersInput {
  customerId?: number | null;
  type?: ArticleType | null;
}

export interface BulkImportCustomersInput {
  leads: CustomerLeadInput[];
  categoryId?: number | null;
  findBy?: FindBySource | null;
  status?: CustomerStatus | null;
}

export interface BulkImportSalesArgumentsInput {
  items: SalesArgumentItemInput[];
}

export interface ContactsFiltersInput {
  search?: string | null;
  customerId?: number | null;
  active?: boolean | null;
}

export interface CreateArticleInput {
  site: string;
  type: ArticleType;
  title: string;
  content: string;
  customerId: number;
}

export interface CreateCategoryInput {
  name: string;
}

export interface CreateCmsInput {
  name: string;
}

export interface CreateContactInput {
  civility: string;
  lastname: string;
  firstname: string;
  email?: string | null;
  phone: string;
  isPrimary: boolean;
  active: boolean;
  notes: string;
  customerId: number;
}

export interface CreateCustomerInput {
  name: string;
  email?: string | null;
  phone?: string | null;
  site?: string | null;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  findBy?: FindBySource | null;
  todo?: string | null;
  status?: CustomerStatus | null;
  analyseDone?: boolean | null;
  problemsDetected?: boolean | null;
  hidden?: boolean | null;
  categoryId?: number | null;
  cmsId?: number | null;
  cmsName?: string | null;
}

export interface CreateCustomerTaskInput {
  title: string;
  description: string;
  customerId: number;
  priority?: number | null;
  assignedToId?: number | null;
}

export interface CreateMailboxInput {
  email: string;
  imapHost: string;
  imapPort: number;
  smtpHost: string;
  smtpPort: number;
  password: string;
}

export interface CreatePromptFragmentInput {
  code: string;
  name: string;
  promptText: string;
}

export interface CreateProspectionInput {
  type: ProspectionType;
  automatique: boolean;
  phone?: string | null;
  email?: string | null;
  message: string;
  customerId?: number | null;
}

export interface CreateReportInput {
  weekStartDate: any;
  content: string;
  customerId: number;
}

export interface CreateSalesArgumentInput {
  theme: string;
  content: string;
}

export interface CreateThemeInput {
  code: string;
  name: string;
  promptText: string;
}

export interface CreateUserInput {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  role: UserRole;
}

export interface CreatedSitesFiltersInput {
  customerId?: number | null;
  themeId?: number | null;
  status?: CreatedSiteStatus | null;
  promptFragmentId?: number | null;
}

export interface CustomerLeadInput {
  nom: string;
  telephone?: string | null;
  email?: string | null;
  site?: string | null;
  adresse?: string | null;
  url?: string | null;
}

export interface CustomerSortInput {
  field: CustomerSortField;
  order: SortOrder;
}

export interface CustomerTasksFiltersInput {
  customerId?: number | null;
  assignedToId?: number | null;
  createdById?: number | null;
  status?: CustomerTaskStatus | null;
}

export interface CustomersFiltersInput {
  search?: string | null;
  categoryId?: number | null;
  cmsId?: number | null;
  email?: string | null;
  status?: CustomerStatus | null;
  findBy?: FindBySource | null;
  sortBy?: CustomerSortInput[] | null;
}

export interface LoginAsInput {
  email: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

export interface MailMessagesFiltersInput {
  customerId?: number | null;
  mailboxId?: number | null;
  direction?: MailDirection | null;
}

export interface ProspectionsFiltersInput {
  customerId?: number | null;
  sentById?: number | null;
  type?: ProspectionType | null;
  automatique?: boolean | null;
}

export interface ReportsFiltersInput {
  customerId?: number | null;
}

export interface SalesArgumentItemInput {
  theme: string;
  content: string;
}

export interface SendMailMessageInput {
  to: string;
  subject: string;
  body: string;
  customerId?: number | null;
}

export interface UpdateArticleInput {
  site?: string | null;
  type?: ArticleType | null;
  title?: string | null;
  content?: string | null;
  customerId?: number | null;
}

export interface UpdateCategoryInput {
  name?: string | null;
}

export interface UpdateCmsInput {
  name?: string | null;
}

export interface UpdateContactInput {
  civility?: string | null;
  lastname?: string | null;
  firstname?: string | null;
  email?: string | null;
  phone?: string | null;
  isPrimary?: boolean | null;
  active?: boolean | null;
  notes?: string | null;
  customerId?: number | null;
}

export interface UpdateCustomerInput {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  site?: string | null;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  findBy?: FindBySource | null;
  todo?: string | null;
  status?: CustomerStatus | null;
  analyseDone?: boolean | null;
  problemsDetected?: boolean | null;
  hidden?: boolean | null;
  categoryId?: number | null;
  cmsId?: number | null;
  cmsName?: string | null;
}

export interface UpdateCustomerTaskInput {
  title?: string | null;
  description?: string | null;
  customerId?: number | null;
  priority?: number | null;
  assignedToId?: number | null;
  status?: CustomerTaskStatus | null;
}

export interface UpdateMailboxInput {
  email?: string | null;
  imapHost?: string | null;
  imapPort?: number | null;
  smtpHost?: string | null;
  smtpPort?: number | null;
  password?: string | null;
  active?: boolean | null;
}

export interface UpdatePromptFragmentInput {
  code?: string | null;
  name?: string | null;
  promptText?: string | null;
}

export interface UpdateProspectionInput {
  type?: ProspectionType | null;
  automatique?: boolean | null;
  phone?: string | null;
  email?: string | null;
  message?: string | null;
  customerId?: number | null;
}

export interface UpdateReportInput {
  weekStartDate?: any | null;
  content?: string | null;
  customerId?: number | null;
}

export interface UpdateSalesArgumentInput {
  theme?: string | null;
  content?: string | null;
}

export interface UpdateThemeInput {
  code?: string | null;
  name?: string | null;
  promptText?: string | null;
}

export interface UpdateUserInput {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  password?: string | null;
  role?: UserRole | null;
}

export interface UsersFiltersInput {
  search?: string | null;
  role?: UserRole | null;
  roles?: UserRole[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
